import { useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import api, { formatApiError } from "../api/client";
import { AdminTabs } from "./AdminDashboard";

export default function AdminSettings() {
    const [oldPw, setOldPw] = useState("");
    const [newPw, setNewPw] = useState("");
    const [confirmPw, setConfirmPw] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (newPw.length < 8) { toast.error("new password must be at least 8 characters"); return; }
        if (newPw !== confirmPw) { toast.error("new passwords do not match"); return; }
        setBusy(true);
        try {
            await api.post("/admin/me/password", { old_password: oldPw, new_password: newPw });
            toast.success("Password changed. Use the new one on next login.");
            setOldPw(""); setNewPw(""); setConfirmPw("");
        } catch (e) {
            toast.error("change failed", { description: formatApiError(e.response?.data?.detail) });
        } finally { setBusy(false); }
    };

    return (
        <div className="bg-[#050505] min-h-[calc(100vh-3.5rem)] bg-grid-fine">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 grid gap-6">
                <div>
                    <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-cyan-400">Admin · Settings</div>
                    <h1 className="mt-2 text-2xl sm:text-3xl font-medium tracking-tighter">Account settings</h1>
                </div>
                <AdminTabs />

                <form onSubmit={submit} className="bg-[#0A0A0C] border border-[#1F1F24] rounded-sm p-5 sm:p-6 grid gap-4" data-testid="password-form">
                    <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-zinc-500">Change password</div>
                    <Field label="Current password">
                        <input data-testid="old-password-input" type="password" value={oldPw} onChange={(e) => setOldPw(e.target.value)} required
                            className="w-full bg-transparent border-b border-[#1F1F24] focus:border-cyan-400 outline-none py-2 font-mono text-sm" />
                    </Field>
                    <Field label="New password (min 8 chars)">
                        <input data-testid="new-password-input" type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} minLength={8} required
                            className="w-full bg-transparent border-b border-[#1F1F24] focus:border-cyan-400 outline-none py-2 font-mono text-sm" />
                    </Field>
                    <Field label="Confirm new password">
                        <input data-testid="confirm-password-input" type="password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} required
                            className="w-full bg-transparent border-b border-[#1F1F24] focus:border-cyan-400 outline-none py-2 font-mono text-sm" />
                    </Field>
                    <button type="submit" disabled={busy} data-testid="password-submit"
                        className="inline-flex items-center gap-2 px-5 py-2.5 bg-cyan-400 hover:bg-cyan-300 disabled:opacity-50 text-black font-semibold text-xs uppercase tracking-widest rounded-sm w-fit">
                        <Save className="w-4 h-4" /> {busy ? "Saving…" : "Change password"}
                    </button>
                </form>
            </div>
        </div>
    );
}

function Field({ label, children }) {
    return (
        <div className="grid gap-1.5">
            <label className="text-[10px] font-mono uppercase tracking-[0.22em] text-zinc-500">{label}</label>
            {children}
        </div>
    );
}
